<template>
    <div class="wl-container">
        <div class="course-content" v-loading="loading">
            <el-tabs type="border-card" v-model="activeName" @tab-click="onSizeChange(8)">
                <el-tab-pane :label="$t('kee_online_courses')" name="ONLINE"></el-tab-pane>
                <el-tab-pane v-if="!!offlineDataLength" :label="$t('kee_offline_courses')" name="OFFLINE"></el-tab-pane>
            </el-tabs>
            <div class="search-content">
                <el-input v-model="searchInput" :placeholder="$t('please_input')">
                    <el-button slot="append" icon="el-icon-search" type="primary" size="small" @click="getTable">
                        {{ $t('btn_search2') }}
                    </el-button>
                </el-input>
                <el-button v-if="!isKpmgUser" icon="el-icon-star-off" size="small" class="wl-green-small" @click="goToMyCourse">
                    {{ $t('kee_my') }}
                </el-button>
            </div>
            <div class="course-list" v-if="courseList.length">
                <div class="course-item-outer" v-for="item in courseList" :key="item.courseId">
                    <div class="course-item" @click="goDetail(item)">
                        <div class="isNew" v-if="item.newCourseFlag">New</div>
                        <img :src="item.coverImgUrl" alt="" class="course-pic" />
                        <div class="title-row">
                            <el-tooltip :content="item.title" :disabled="item.title.length <= 24">
                                <div class="course-title">
                                    {{ item.title }}
                                </div>
                            </el-tooltip>
                            <div class="course-price" :class="item.chargeType === 'FREE' ? 'free' : ''">
                                {{ item.chargeType === 'FREE' ? $t('kee_free') : $t('kee_charge') }}
                            </div>
                        </div>
                        <div class="course-item-child">
                            <div class="course-time" v-show="activeName === 'ONLINE'">
                                {{ $t('kee_duration') }}: {{ durationTrans(item.sumDurationFormat) }}
                            </div>
                            <div
                                :class="['course-collect', getUser.userType == '2' ? '' : 'course-collect-kp']"
                                @click.stop="collectClick(item)"
                            >
                                <img src="@/assets/img/icon-collect.svg" v-if="item.collectFlag" class="collect-icon" width="100%" />
                                <img src="@/assets/img/icon-uncollect.svg" v-else class="collect-icon" width="100%" />
                                <span>{{ $t('kee_like') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-empty class="course-list" v-else :description="$t('TABLE_NO_DATA')"></el-empty>
            <el-pagination
                class="wl-pagination"
                :current-page="pagination.pageNum"
                :page-size="pagination.pageSize"
                @size-change="onSizeChange"
                @current-change="onCurrentPageChange"
                :page-sizes="[8, 16, 24, 48, 96]"
                layout="prev, pager, next, sizes, total"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
        <div v-if="$route.query.kccTag === 'TAX_COURSES'" :class="['qrcode', isOpen ? 'is-open' : 'not-open']">
            <div v-show="!isOpen" @click="isOpen = !isOpen" class="not-open-inner" :title="$t('kpmgFinanceOnline')">
                <img src="@/assets/img/kee/icon.png" width="25" alt="">
                <div>{{ $t('kpmgFinanceOnline') }}</div>
            </div>
            <div v-show="isOpen" class="is-open-inner">
                <div @click="isOpen = !isOpen" class="close">
                    {{ $t('fold') }} X
                </div>
                <div class="tit">
                    <img src="@/assets/img/kee/icon.png" width="25" alt="">
                    <span>{{ $t('kpmgFinanceOnline') }}</span>
                </div>
                <img src="@/assets/img/kee/qrcode.png" style="width: 100%;" alt="">
                <p>{{ $t('qrcodeTips') }}</p>
            </div>
        </div>

    </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import Tooltip from '@/components/common/Tooltip.vue'
export default {
    name: 'courseList',
    components: { Tooltip },
    data() {
        return {
            isOpen: false,
            searchInput: '',
            activeName: 'ONLINE',
            offlineDataLength: 0,
            courseList: [],
            pagination: {
                pageNum: 1,
                pageSize: 8,
                total: 0
            },
            loading: false
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser'
        }),
        isKpmgUser() {
            return this.getUser.userType === '1'
        },
        kccTag() {
            if (this.$route.query.kccTag) {
                localStorage.setItem('kee_list_kccTag', this.$route.query.kccTag)
                return this.$route.query.kccTag
            } else {
                const kccTag = localStorage.getItem('kee_list_kccTag')
                if (kccTag) {
                    this.$route.query.kccTag = kccTag
                    return kccTag
                } else {
                    return ''
                }
            }
        }
    },
    mounted() {
        this.getTable()
        // 初始化时查询线下活动，无数据时隐藏相应tab页签
        this.getTable('OFFLINE')
    },
    methods: {
        durationTrans(v) {
            return [v[0], this.$t('hour'), v[1], this.$t('minute'), v[2], this.$t('second')].join(' ')
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getTable()
        },
        onSizeChange(current) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = current
            this.getTable()
        },
        getTable(activeName) {
            // if (this.activeName == 'OFFLINE') {
            //   this.courseList = []
            //   this.pagination.total = 0
            //   return
            // }
            this.loading = true
            let param = {
                fuzzy: this.searchInput,
                form: activeName || this.activeName,
                pageNum: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                kccTag: this.kccTag
            }
            API.insights.queryCourseInfo(param).then((res) => {
                if (res.code === '1') {
                    if (activeName === 'OFFLINE') {
                        // 初始化时查询线下活动，无数据时隐藏相应tab页签
                        this.offlineDataLength = res.data.size
                    } else {
                        this.courseList = res.data.records || []
                        this.pagination.total = res.data.total
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        },
        goDetail(item) {
            this.$router.push({ name: 'courseDetail', query: { courseId: item.courseId } })
        },
        goToMyCourse() {
            this.$router.push({ name: 'myCourse' })
        },
        collectClick(item) {
            let param = {
                courseId: item.courseId,
                flag: item.collectFlag ? 0 : 1
            }
            API.insights.updateCollectFlagRecord(param).then((res) => {
                if (res.code === '1') {
                    if (item.collectFlag) {
                        item.collectFlag = 0
                    } else {
                        item.collectFlag = 1
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        }
    }
}
</script>

<style scoped>
.wl-container {
    color: #444;
    height: 100%;
    background: #eff1f5;
    padding: 15px;
    position: relative;
}
.course-content {
    height: 100%;
    background-color: white;
    border-radius: 8px;
    position: relative;
}

.qrcode {
    position: absolute;
    right: 25px;
    top: 120px;
    box-shadow: 0 0 1px #ebebeb;
    transition: all .2s;
}
.qrcode.not-open {
    width: 35px;
    border-radius: 20px;
    cursor: pointer;
    background-image: url('~@/assets/img/kee/bg-not-open.png');
    background-position: 0;
}
.qrcode .not-open-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px 0;
}
.qrcode .not-open-inner div {
    writing-mode: vertical-lr;
    font-size: 13px;
    letter-spacing: 3px;
    color: #fff;
    margin-top: 10px;
}

.en-lang .qrcode .not-open-inner div {
    display: none;
}

.qrcode.is-open {
    padding: 0 15px;
    border-radius: 8px;
    cursor: default;
    background-image: url('~@/assets/img/kee/bg-open.png');
    background-size: 100%;
}

.qrcode .is-open-inner {
    padding: 15px 0 10px 0;
    text-align: center;
}

.qrcode .is-open-inner .close {
    position: absolute;
    top: 0px;
    right: 2px;
    font-size: 12px;
    transform: scale(0.9);
    color: rgb(29, 44, 200);
    cursor: pointer;
}

.en-lang .qrcode .is-open-inner .close {
    top: 4px;
    right: 8px;
    transform: scale(1);
}

.qrcode .is-open-inner .tit {
    display: flex;
    align-items: center;
    font-size: 13px;
    margin: 10px 0;
}
.qrcode .is-open-inner .tit span {
    margin-left: 5px;
    color: #fff;
}

.qrcode .is-open-inner img {
    border-radius: 5px;
    max-width: 150px;
}

.qrcode .is-open-inner p {
    text-align: center;
    color: #fff;
    margin-top: 5px;
}

.search-content {
    position: absolute;
    display: flex;
    right: 20px;
    top: 7px;
}
::v-deep .el-tabs__header {
    padding: 0 !important;
    border-bottom: none;
    background-color: #e3e4e6;
}
::v-deep .el-tabs--border-card {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: none;
    overflow: hidden;
    box-shadow: none;
}
::v-deep .el-tabs__nav {
    height: 43px;
}
::v-deep .course-content .el-tabs__item {
    color: #333333 !important;
    font-size: 13px !important;
    font-weight: bold !important;
    height: 43px;
    line-height: 43px;
    padding: 0 20px !important;
    border: none !important;
}
::v-deep .el-tabs__item.is-active {
    color: #3879eb !important;
    border-top: 3px solid #3879eb !important;
}
::v-deep .el-tabs__content {
    padding: 0;
}
::v-deep .el-input-group > .el-input__inner {
    height: 28px;
}
::v-deep .el-input-group__append button.el-button {
    border-color: #3879eb;
    background-color: #3879eb;
    color: white;
    height: 28px;
}
.wl-green-small {
    height: 28px;
    margin-left: 10px;
}

.course-list {
    /* padding: 15PX 20PX;
    height: calc(100% - 30PX - 48px);
    overflow: auto; */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 10px;
    height: calc(100% - 110px);
    overflow-y: auto;
}

.course-list::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px !important; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px !important;
}

.course-list.el-empty {
    flex-direction: column;
}
.course-list .course-item-outer {
    width: calc(25% - 20px);
    margin: 10px;
}
.course-list .course-item-outer .course-item {
    padding: 25px 20px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s linear;
    text-align: center;
}
.course-list .course-item-outer .course-item:hover {
    box-shadow: 1px 1px 8px 8px #efeff5;
}
.course-list .course-item-outer .course-item .isNew {
    position: absolute;
    padding: 4px 7px;
    right: 0;
    top: 0;
    color: white;
    background-color: #00b8f5;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
}


.course-list .course-item-outer .course-item .title-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 100px;
}
.course-list .course-item-outer .course-item .title-row .course-price {
    font-size: 14px;
}
.course-list .course-item-outer .course-item .course-item-child {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.course-list-item {
    padding: 20px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    margin: auto;
    margin-bottom: 20px;
    height: 600px;
}
.course-list-item:hover {
    background-color: rgba(0, 0, 0, 0.1);
    transition: all 1s;
}
.isNew {
    position: absolute;
    padding: 4px 7px;
    right: 0;
    top: 0;
    color: white;
    background-color: #f2b000;
    border-bottom-left-radius: 8px;
}
.margin-bottom-30 {
    margin-bottom: 30px;
}
.course-item-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.course-title {
    color: #00338d;
    font-size: 18px;
    font-weight: bold;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 1.2em;
    max-height: 2.4em;
}
.course-price {
    font-size: 18px;
    color: #fd349c;
}
.free {
    color: #00c0ae;
}
.course-time {
    color: #636363;
    font-size: 14px;
}
.course-collect {
    color: #333333;
    font-size: 14px;
    display: flex;
    cursor: pointer;
}
.course-collect-kp {
    visibility: hidden;
}
.collect-icon {
    height: 16px;
    width: 16px;
    margin-right: 5px;
    margin-top: 1px;
}
.course-pic {
    height: 380px;
    width: 330px;
    /* width: 100%; */
    /* height: 330px; */
    border-radius: 8px;
    margin-bottom: 10px;
}
.wl-pagination {
    padding-right: 20px !important;
}
</style>
